import type { ReactElement } from 'react';
import styles from './PinEntryScreen.module.css';

export interface PinDisplayProps {
  pin: string;
  length: number;
}

/**
 * Exibe o PIN digitado como bullets mascarados + contador "N/length"
 * (HUB-235, CA-08). Puramente apresentacional — nunca revela os dígitos.
 */
export function PinDisplay({ pin, length }: PinDisplayProps): ReactElement {
  return (
    <div className={styles.display} role="textbox" aria-label="PIN de 6 dígitos" aria-readonly="true">
      <div className={styles.dots} aria-hidden="true">
        {Array.from({ length }, (_, index) => (
          <span
            key={index}
            className={`${styles.dot} ${index < pin.length ? styles.dotFilled : ''}`}
          />
        ))}
      </div>
      <span className={styles.counter}>
        {pin.length}/{length}
      </span>
    </div>
  );
}
